import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowRightDownCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-right-down-circle"} maskId="square-filled-radius-0-stroke-1-IconArrowRightDownCircle"><path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16 16H9V15H14.2929L7.79289 8.5L8.5 7.79289L15 14.2929V9H16V16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowRightDownCircle;
